import { getQueryParam } from '@mi-front/core';

const apiRoot = getQueryParam('API_ROOT') || import.meta.env.VITE_API_ROOT.replace(/\/?$/, '');
const appEnv = import.meta.env.VITE_ENV as 'prod' | 'dev' | 'prod-preview';
const isStorybook = import.meta.env.VITE_ENV === 'storybook';

export const config = {
  appEnv,
  apiRoot,
  isAppDev: import.meta.env.VITE_ENV === 'dev',
  isNodeDev: import.meta.env.DEV,
  isNodeProd: import.meta.env.PROD,
  isTest: import.meta.env.MODE === 'test',
  appVersion: import.meta.env.VITE_VERSION,
  bugsnagKey: import.meta.env.VITE_BUGSNAG_KEY,
  auth0: {
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    domain: import.meta.env.VITE_AUTH0_APP_DOMAIN,
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  },
  isStorybook,
  forceLocale: isStorybook ? 'en' : import.meta.env.VITE_LOCALE,
  growthbookClientKey: import.meta.env.VITE_GROWTHBOOK_CLIENT_KEY,
  posthogKey: import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
  posthogHost: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  videoEditorUrl: (() => {
    const url = import.meta.env.VITE_VIDEO_EDITOR_URL;

    if (!url) {
      return appEnv === 'prod'
        ? 'https://editor.mediainbox.io'
        : 'https://editor-dev.mediainbox.io';
    }

    return url.replace(/\/?$/, '');
  })(),
};
